export const setCodeValue = ({commit}, data) => {
  commit("setCodeValue", data);  // 这里的变量名需与mutations中保持一致
}

export const setSignalRState = ({commit}, data) => {
  commit("setSignalRState", data);
}

export const setDeviceStates = ({commit}, data) => {
  commit("setDeviceStates", data);
}

export const setDeviceUnfold = ({commit}, data) => {
  commit("setDeviceUnfold", data);
}

export const setUserState = ({commit}, data) => {
  commit("setUserState", data);
}

export const setEnergyState = ({commit}, data) => {
  commit("setEnergyState", data);
}

export const setDeviceAlarm = ({commit}, data) => {
  commit("setDeviceAlarm", data);
}

export const setUseGasState = ({commit}, data) => {
  commit("setUseGasState", data);
}

export const setUserItem = ({commit}, data) => {
  commit("setUserItem", data);
}

export const setThemeCode = ({commit}, data) => {
  commit("setThemeCode", data);
}

export const setHomeType = ({commit}, data) => {
  commit("setHomeType", data);
}


// WEBPACK FOOTER //
// ./src/store/actions.js